import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, Grid, InputAdornment, CircularProgress, MenuItem, List, ListItem, ListItemIcon, ListItemText,
  Autocomplete, FormControl, FormLabel, FormGroup, Alert } from '@mui/material';
import { toast } from 'react-toastify';
import CheckIcon from '@mui/icons-material/Check';
import WarningIcon from '@mui/icons-material/Warning';

// List of US States
const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

const genderOptions = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" }
];

// Required fields function
const getRequiredFields = (countyId) => {
  const defaultFields = ['firstName', 'lastName', 'totalBondAmount'];
  const requiredFields = {
    // Bell County - 55941
    55941: [
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'defendantPhoneNumber',
      'socialSecurityNumber',
      'placeOfBirth',
      'hairColor',
      'eyeColor',
      'race',
      'weight',
      'jailInfo',
    ],
    // Cameron County - 55853
    55853: [
      'nearestRelativeName',
      'nearestRelativeAddressStreet1',
      'nearestRelativeAddressCity',
      'nearestRelativeAddressState',
      'nearestRelativeAddressZipCode',
    ],
    // Comal County - 56002
    56002: [
      'height',
      'weight',
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'defendantPhoneNumber',
      'driversLicenseNumber',
      'nextOfKinName',
      'nextOfKinPhoneNumber',
      'nextOfKinAddressStreet1',
      'nextOfKinAddressCity',
      'nextOfKinAddressState',
      'nextOfKinAddressZipCode',
    ],
    // Coryell County - 55874
    55874: ['driversLicenseNumber', 'socialSecurityNumber', 'placeOfBirth'],
    // Dallas County - 55857
    55857: [
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'firstName',
      'lastName',
      'dateOfBirth',
      'gender',
      'race',
      'bookingNumber',
    ],
    // Ellis County - 55926
    55926: [
      'nextOfKinName',
      'nextOfKinPhoneNumber',
      'nextOfKinAddressStreet1',
      'nextOfKinAddressCity',
      'nextOfKinAddressState',
      'nextOfKinAddressZipCode',
      'height',
      'weight',
      'hairColor',
      'eyeColor',
      'race',
      'gender',
      'driversLicenseNumber',
      'driversLicenseState',
      'placeOfBirth',
    ],
    // Galveston County - 55881
    55881: [
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'height',
      'weight',
    ],
    // Harris County - 55856 (Specific handling required)
    55856: [],
    // Hidalgo County - 55852
    55852: [
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'defendantPhoneNumber',
      'eyeColor',
      'hairColor',
      'weight',
      'placeOfBirth',
    ],
    // Midland County - 55991
    55991: ['arrestDate'],
    // Parker County - 55872
    55872: [
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'dateOfBirth',
    ],
    // Wise County - 55885
    55885: [
      'defendantStreet',
      'defendantCity',
      'defendantState',
      'defendantZipCode',
      'dateOfBirth',
    ],
    // Tarrant County - 55912
    55912: [
      'dateOfBirth',
    ],
    //ALAMEDA County - 53706
    53706: [
      'pfnNumber'
    ]

  };
  return [...defaultFields, ...(requiredFields[countyId] || [])];
};

const QuoteDetailsModal = ({ open, handleClose, quote, refreshHandler, bondDetails }) => {
  const [firstName, setFirstName] = useState('');
  const [middleInitial, setMiddleInitial] = useState('');
  const [lastName, setLastName] = useState('');
  const [totalBondAmount, setTotalBondAmount] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [bookingNumber, setBookingNumber] = useState('');
  const [driversLicenseNumber, setDriversLicenseNumber] = useState('');
  const [driversLicenseState, setDriversLicenseState] = useState('');
  const [race, setRace] = useState('');
  const [gender, setGender] = useState('');
  const [arrestDate, setArrestDate] = useState('');
  const [courtCode, setCourtCode] = useState('');
  const [courtPlace, setCourtPlace] = useState('');
  const [jailPhoneNumber, setJailPhoneNumber] = useState('');
  const [jailInfo, setJailInfo] = useState('');
  const [city, setCity] = useState('');
  const [placeOfBirth, setPlaceOfBirth] = useState('');
  const [socialSecurityNumber, setSocialSecurityNumber] = useState('');
  const [powers, setPowers] = useState([]);
  const [defendantStreet, setDefendantStreet] = useState('');
  const [defendantState, setDefendantState] = useState('');
  const [defendantZipCode, setDefendantZipCode] = useState('');
  const [defendantCity, setDefendantCity] = useState('');
  const [defendantPhoneNumber, setDefendantPhoneNumber] = useState('');

  const [hairColor, setHairColor] = useState('');
  const [eyeColor, setEyeColor] = useState('');
  const [weight, setWeight] = useState('');
  const [height, setHeight] = useState('');

  const [nearestRelativeName, setNearestRelativeName] = useState('');

  const [nextOfKinName, setNextOfKinName] = useState('');
  const [nextOfKinPhoneNumber, setNextOfKinPhoneNumber] = useState('');

  const [nearestRelativeAddressStreet1, setNearestRelativeAddressStreet1] = useState('');
  const [nearestRelativeAddressStreet2, setNearestRelativeAddressStreet2] = useState('');
  const [nearestRelativeAddressCity, setNearestRelativeAddressCity] = useState('');
  const [nearestRelativeAddressState, setNearestRelativeAddressState] = useState('');
  const [nearestRelativeAddressZipCode, setNearestRelativeAddressZipCode] = useState('');

  const [nextOfKinAddressStreet1, setNextOfKinAddressStreet1] = useState('');
  const [nextOfKinAddressStreet2, setNextOfKinAddressStreet2] = useState('');
  const [nextOfKinAddressCity, setNextOfKinAddressCity] = useState('');
  const [nextOfKinAddressState, setNextOfKinAddressState] = useState('');
  const [nextOfKinAddressZipCode, setNextOfKinAddressZipCode] = useState('');

  const [xrefNumber, setXrefNumber] = useState('');
  const [pfnNumber, setPfnNumber] = useState('');

  const [loading, setLoading] = useState(false);

  // State for Decline Modal
  const [declineModalOpen, setDeclineModalOpen] = useState(false);
  const [declineReason, setDeclineReason] = useState('');
  const [declineLoading, setDeclineLoading] = useState(false);

  const transferBondTransactionID = quote?.transferBondTransactionID; // Assuming this is part of the quote object

  const countyId = bondDetails?.countyId;
  const requiredFields = getRequiredFields(countyId);


  // Prefill fields with bondDetails if they exist
  useEffect(() => {
    if (bondDetails) {
      setFirstName(bondDetails.defendantFirstName || '');
      setMiddleInitial(bondDetails.defendantMiddleInitial || '');
      setLastName(bondDetails.defendantLastName || '');
      setTotalBondAmount(bondDetails.totalBondAmount || '');
      
      let powerArray = [];
      for ( let index = 0 ; index < bondDetails.numberOfBonds; index++) {
        powerArray.push({
          id: index,
          bondAmount: 0,
          charge: '',
          chargeType: '',
          caseNumber:'',
          courtPlace: bondDetails.courtPlace || '',
          courtDate:''
        })
      }
      setPowers(powerArray);
    }
  }, []);

  const handleSubmit = async () => {

    // First make sure they are not over underwriting authority. call the API and notify user if so
    try {
      const token = localStorage.getItem('jwtToken');
      const baseURL = process.env.REACT_APP_BASE_URL;
      const response = await fetch(
        `${baseURL}RequestingTransferBond/${bondDetails.requestingAgentID}/UnderWritingAuhtority`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Issue handling UWA.');
      }

      const Uwa = await response.json();

      const totalBondAmountNumber = parseFloat(totalBondAmount);

      if (totalBondAmountNumber > Uwa && !bondDetails.authorizedBy) {
          toast.warning('This bond amount is over your underwriting authority. Please call Bankers Surety for assistance.');
          return;
      }
    } catch (error) {
      console.error('Error Getting Underwriting Authroity', error);
      toast.error(error.message || 'Error Getting Underwriting Authroity');
      return;
    } finally {
      setLoading(false);
    }


    // Validation for required fields
    const fieldValues = {
      firstName: firstName.trim(),
      middleInitial: middleInitial.trim(),
      lastName: lastName.trim(),
      totalBondAmount: totalBondAmount,
      dateOfBirth: dateOfBirth,
      bookingNumber: bookingNumber.trim(),
      driversLicenseNumber: driversLicenseNumber.trim(),
      driversLicenseState: driversLicenseState,
      race: race.trim(),
      gender: gender,
      arrestDate: arrestDate,
      courtCode: courtCode.trim(),
      courtPlace: courtPlace.trim(),
      jailPhoneNumber: jailPhoneNumber.trim(),
      jailInfo: jailInfo.trim(),
      city: city.trim(),
      placeOfBirth: placeOfBirth.trim(),
      socialSecurityNumber: socialSecurityNumber.trim(),
      defendantStreet: defendantStreet.trim(),
      defendantCity: defendantCity.trim(),
      defendantState: defendantState,
      defendantZipCode: defendantZipCode.trim(),
      defendantPhoneNumber: defendantPhoneNumber.trim(),
      hairColor: hairColor.trim(),
      eyeColor: eyeColor.trim(),
      weight: weight,
      height: height,
      nearestRelativeName: nearestRelativeName.trim(),
      nearestRelativeAddressStreet1: nearestRelativeAddressStreet1.trim(),
      nearestRelativeAddressCity: nearestRelativeAddressCity.trim(),
      nearestRelativeAddressState: nearestRelativeAddressState,
      nearestRelativeAddressZipCode: nearestRelativeAddressZipCode.trim(),
      nextOfKinName: nextOfKinName.trim(),
      nextOfKinPhoneNumber: nextOfKinPhoneNumber.trim(),
      nextOfKinAddressStreet1: nextOfKinAddressStreet1.trim(),
      nextOfKinAddressCity: nextOfKinAddressCity.trim(),
      nextOfKinAddressState: nextOfKinAddressState,
      nextOfKinAddressZipCode: nextOfKinAddressZipCode.trim(),
      xrefNumber: xrefNumber.trim(),
      pfnNumber: pfnNumber.trim(),
      powers: powers, 
      courtDateFound: powers.map((power) => { if (!power.courtDate) return power.courtDate; }).length === powers.length,
      chargeType: powers.map((power) => { if (!power.chargeType) return power.chargeType; }).length === powers.length,
    };

    const fieldLabels = {
      firstName: 'First Name',
      middleInitial: 'Middle Initial',
      lastName: 'Last Name',
      totalBondAmount: 'Total Bond Amount',
      dateOfBirth: 'Date of Birth',
      bookingNumber: 'Booking Number',
      driversLicenseNumber: "Driver's License Number",
      driversLicenseState: "Driver's License State",
      race: 'Race',
      gender: 'Gender',
      arrestDate: 'Arrest Date',
      courtCode: 'Court Code',
      jailPhoneNumber: 'Jail Phone Number',
      jailInfo: 'Jail Info',
      city: 'City',
      placeOfBirth: 'Place of Birth',
      socialSecurityNumber: 'Social Security Number',
      defendantStreet: 'Defendant Street',
      defendantCity: 'Defendant City',
      defendantState: 'Defendant State',
      defendantZipCode: 'Defendant Zip Code',
      defendantPhoneNumber: 'Defendant Phone Number',
      hairColor: 'Hair Color',
      eyeColor: 'Eye Color',
      weight: 'Weight',
      height: 'Height',
      nearestRelativeName: 'Nearest Relative Name',
      nearestRelativeAddressStreet1: 'Nearest Relative Street',
      nearestRelativeAddressCity: 'Nearest Relative City',
      nearestRelativeAddressState: 'Nearest Relative State',
      nearestRelativeAddressZipCode: 'Nearest Relative Zip Code',
      nextOfKinName: 'Next of Kin Name',
      nextOfKinPhoneNumber: 'Next of Kin Phone Number',
      nextOfKinAddressStreet1: 'Next of Kin Street',
      nextOfKinAddressCity: 'Next of Kin City',
      nextOfKinAddressState: 'Next of Kin State',
      nextOfKinAddressZipCode: 'Next of Kin Zip Code',
      courtDateFound: 'Court Date for all powers',
      chargeType: 'Charge Type',
      xrefNumber: 'XREF Number',
      pfnNumber: 'PFN Number',
    };

    for (const field of requiredFields) {
      const value = fieldValues[field];
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        toast.error(`${fieldLabels[field]} is required.`);
        return;
      }

      // Additional validation for specific fields
      if (field === 'totalBondAmount' && parseFloat(value) <= 0) {
        toast.error('Total Bond Amount must be greater than 0.');
        return;
      }

      if (['defendantZipCode', 'nearestRelativeAddressZipCode', 'nextOfKinAddressZipCode'].includes(field) && !/^\d{5}$/.test(value)
      ) {
        toast.error(`${fieldLabels[field]} must be a 5-digit number.`);
        return;
      }
      
      if (fieldValues['defendantZipCode'] && fieldValues['defendantZipCode'].length !== 5) {
        toast.error(`Defendant's Zip Code must be a valid 5-digit number.`);
        return;
      }

      if (fieldValues['nearestRelativeAddressZipCode'] && fieldValues['nearestRelativeAddressZipCode'].length !== 5) {
        toast.error(`Nearest Relative's Zip Code must be a valid 5-digit number.`);
        return;
      }

      if (fieldValues['nextOfKinAddressZipCode'] && fieldValues['nextOfKinAddressZipCode'].length !== 5) {
        toast.error(`Next of Kin's Zip Code must be a valid 5-digit number.`);
        return;
      }

      if (
        ['defendantPhoneNumber', 'nextOfKinPhoneNumber', 'jailPhoneNumber'].includes(field) &&
        !/^\d+$/.test(value)
      ) {
        toast.error(`${fieldLabels[field]} must contain only numbers.`);
        return;
      }

      if (['weight', 'height'].includes(field) && !/^\d+$/.test(value)) {
        toast.error(`${fieldLabels[field]} must be a number.`);
        return;
      }
    }

    for (const power of powers) {

      if (!(parseFloat(power.bondAmount) > 0)) {
        toast.error(`Bond amount is required for Power #${power.id+1}`);
        return;
      }

      if (!power.charge) {
        toast.error(`Charge is required (Power #${power.id+1}).`);
        return;
      }

      if (requiredFields.includes('chargeType') && !power.chargeType) {
        toast.error(`Charge Type is required (Power #${power.id+1}).`);
        return;
      }

      if (requiredFields.includes('courtDateFound') && !power.courtDate) {
        toast.error(`Court Date is required (Power #${power.id+1}).`);
        return;
      }
    };

    // Validate that individual bond amounts sum to the total bond amount
    const totalBondAmountNumber = parseFloat(totalBondAmount) || 0;
    const sumOfPowerAmounts = powers.reduce((sum, power) => sum + (parseFloat(power.bondAmount) || 0), 0);
    if (Math.abs(sumOfPowerAmounts - totalBondAmountNumber) > 0.01) {
      toast.error(`The sum of individual bond amounts ($${sumOfPowerAmounts.toFixed(2)}) must equal the Total Bond Amount ($${totalBondAmountNumber.toFixed(2)}).`);
      return;
    }

    setLoading(true);

    const requestBody = {
      quoteId: quote?.transferBondQuoteID || 0,
      firstName: firstName.trim(),
      middleInitial: middleInitial.trim(),
      lastName: lastName.trim(),
      totalBondAmount: parseFloat(totalBondAmount),
      dateOfBirth: dateOfBirth ? new Date(dateOfBirth).toISOString() : null,
      bookingNumber: bookingNumber.trim(),
      driversLicenseNumber: driversLicenseNumber.trim(),
      driversLicenseState: driversLicenseState.trim(),
      race: race.trim(),
      gender: gender.trim(),
      arrestDate: arrestDate ? new Date(arrestDate).toISOString() : null,
      courtCode: courtCode.trim(),
      jailPhoneNumber: jailPhoneNumber.trim(),
      jailInfo: jailInfo.trim(),
      city: city.trim(),
      placeOfBirth: placeOfBirth.trim(),
      socialSecurityNumber: socialSecurityNumber.trim(),
      defendantStreet: defendantStreet.trim(),
      defendantCity: defendantCity.trim(),
      defendantState: defendantState.trim(),
      defendantZipCode: defendantZipCode.trim(),
      defendantPhoneNumber: defendantPhoneNumber.trim(),
      hairColor: hairColor.trim(),
      eyeColor: eyeColor.trim(),
      weight: weight ? parseFloat(weight) : null,
      height: height ? parseFloat(height) : null,
      nearestRelativeName: nearestRelativeName.trim(),
      nearestRelativeAddress: {
        street1: nearestRelativeAddressStreet1.trim(),
        street2: nearestRelativeAddressStreet2.trim(),
        city: nearestRelativeAddressCity.trim(),
        state: nearestRelativeAddressState.trim(),
        zipCode: nearestRelativeAddressZipCode.trim(),
      },
      nextOfKinName: nextOfKinName.trim(),
      nextOfKinPhoneNumber: nextOfKinPhoneNumber.trim(),
      nextOfKinAddress: {
        street1: nextOfKinAddressStreet1.trim(),
        street2: nextOfKinAddressStreet2.trim(),
        city: nextOfKinAddressCity.trim(),
        state: nextOfKinAddressState.trim(),
        zipCode: nextOfKinAddressZipCode.trim(),
      },
      powers:  powers.map(
        (power) => ({ ...power, courtDate: power.courtDate ? new Date(power.courtDate).toISOString() : null })
      ),
      xrefNumber: xrefNumber.trim(),
      pfnNumber: pfnNumber.trim(),
    };

    try {
      const token = localStorage.getItem('jwtToken');
      const baseURL = process.env.REACT_APP_BASE_URL;

      const response = await fetch(
        `${baseURL}RequestingTransferBond/${transferBondTransactionID}/selectQuote`,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit quote details.');
      }

      toast.success('Quote accepted successfully.');
      refreshHandler(); // Refresh parent component if needed

      handleClose(); // Close the main modal
    } catch (error) {
      console.error('Error submitting quote details:', error);
      toast.error(error.message || 'Error submitting the quote details.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeclineSubmit = async () => {
    // Validation
    if (!declineReason.trim()) {
      toast.error('Please provide a reason for declining the quote.');
      return;
    }

    setDeclineLoading(true);

    const requestBody = {
      quoteId: quote?.transferBondQuoteID || 0,
      reason: declineReason.trim(),
    };

    try {
      const token = localStorage.getItem('jwtToken');
      const baseURL = process.env.REACT_APP_BASE_URL;

      const response = await fetch(
        `${baseURL}RequestingTransferBond/${transferBondTransactionID}/declineQuote`,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to decline the quote.');
      }

      toast.success('Quote declined successfully.');
      refreshHandler(); // Refresh parent component if needed

      // Close both modals
      setDeclineModalOpen(false);
      handleClose();
    } catch (error) {
      console.error('Error declining the quote:', error);
      toast.error(error.message || 'Error declining the quote.');
    } finally {
      setDeclineLoading(false);
    }
  };

  const clearFields = () => {
    setFirstName('');
    setMiddleInitial('');
    setLastName('');
    setTotalBondAmount('');
    setDateOfBirth('');
    setBookingNumber('');
    setDriversLicenseNumber('');
    setDriversLicenseState('');
    setRace('');
    setGender('');
    setArrestDate('');
    setCourtCode('');
    setJailPhoneNumber('');
    setJailInfo('');
    setCity('');
    setPlaceOfBirth('');
    setSocialSecurityNumber('');
    setDefendantStreet('');
    setDefendantCity('');
    setDefendantState('');
    setDefendantZipCode('');
    setDefendantPhoneNumber('');
    setHairColor('');
    setEyeColor('');
    setWeight('');
    setHeight('');
    setNearestRelativeName('');
    setNearestRelativeAddressStreet1('');
    setNearestRelativeAddressStreet2('');
    setNearestRelativeAddressCity('');
    setNearestRelativeAddressState('');
    setNearestRelativeAddressZipCode('');
    setNextOfKinName('');
    setNextOfKinPhoneNumber('');
    setNextOfKinAddressStreet1('');
    setNextOfKinAddressStreet2('');
    setNextOfKinAddressCity('');
    setNextOfKinAddressState('');
    setNextOfKinAddressZipCode('');
    setCourtPlace('');
    setXrefNumber('');
    setPfnNumber('');
  };

  const handleModalClose = () => {
    clearFields();
    handleClose();
  };

  const handleDeclineModalClose = () => {
    setDeclineReason('');
    setDeclineModalOpen(false);
  };

  const updatePower = (id, propertyName, value) => {
    setPowers( 
      (previousPowers) => 
        previousPowers.map(
          (power) => 
           power.id === id ? { ...power, [propertyName]: value} : power
        )
    );
  };
  

  // Function to get InputLabelProps with adjusted font sizes
  const getInputLabelProps = (fieldName) => {
    const baseSx = { fontSize: '1.1rem' }; // Increase label font size
    if (requiredFields.includes(fieldName)) {
      return {
        shrink: true,
        required: true,
        sx: {
          ...baseSx,
          '& .MuiFormLabel-asterisk': {
            color: 'red',
            fontSize: '1.1rem', // Increase asterisk size
          },
        },
      };
    } else {
      return {
        shrink: true,
        sx: baseSx,
      };
    }
  };

  return (
    <>
      {/* Main Quote Details Modal */}
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="quote-details-modal-title"
        aria-describedby="quote-details-form"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
            maxHeight: '85vh',
            overflowY: 'auto',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          {/* Header with Light Gray Background */}
          <Box
            sx={{
              bgcolor: '#f5f5f5',
              p: 2,
              borderRadius: 1,
              mb: 3,
            }}
          >
            <Typography variant="h6" sx={{ textAlign: 'center' }}>
              Accept Quote ({transferBondTransactionID})
            </Typography>
          </Box>

          {/* Informational Bullet Points */}
          <Box sx={{ mb: 3 }}>
            <List>
              <ListItem>
                <ListItemIcon>
                  <CheckIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="By accepting this quote and providing the required fields, you are essentially shaking hands with this posting agent."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Please confirm that the number of bonds and other details of your request are correct prior to accepting this quote. If any of this information changes after you accept, you may be subject to additional fees."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Once you provide the required fields (some counties require more than others), the posting agent and Bankers will be notified and the posting agent will be expected to post the bonds within their promised posting duration. If for any reason they have not, Bankers will contact them and provide you with an update."
                />
              </ListItem>
            </List>
          </Box>

          {/* Payment Required Up Front Warning for LA */}
          {quote?.paymentRequiredUpFront && (
            <Alert severity="warning" icon={<WarningIcon />} sx={{ mb: 3 }}>
              <Typography variant="body1" fontWeight="bold">
                Payment Required Up Front
              </Typography>
              <Typography variant="body2">
                If you accept this quote, you will need to reach out to bankers in order to handle payment upfront.
              </Typography>
            </Alert>
          )}

          {/* Enter Defendant Information */}
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            Enter Defendant Information
          </Typography>

          <Grid container spacing={2}>
            {/* First Name */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                fullWidth
                required={requiredFields.includes('firstName')}
                InputLabelProps={getInputLabelProps('firstName')}
              />
            </Grid>

            {/* Middle Initial */}
            <Grid item xs={12} sm={2}>
              <TextField
                label="Middle Initial"
                value={middleInitial}
                onChange={(e) => setMiddleInitial(e.target.value.slice(0, 1))} // Limit to 1 character
                fullWidth
                inputProps={{ maxLength: 1 }}
                required={requiredFields.includes('middleInitial')}
                InputLabelProps={getInputLabelProps('middleInitial')}
              />
            </Grid>

            {/* Last Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                fullWidth
                required={requiredFields.includes('lastName')}
                InputLabelProps={getInputLabelProps('lastName')}
              />
            </Grid>

            {/* Total Bond Amount */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Total Bond Amount"
                value={totalBondAmount}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, '');
                  setTotalBondAmount(value);
                }}
                fullWidth
                required={requiredFields.includes('totalBondAmount')}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                InputLabelProps={getInputLabelProps('totalBondAmount')}
              />
            </Grid>

            {/* Date of Birth */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Date of Birth"
                type="date"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
                fullWidth
                InputLabelProps={getInputLabelProps('dateOfBirth')}
                required={requiredFields.includes('dateOfBirth')}
              />
            </Grid>

            {/* Booking Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Booking Number"
                value={bookingNumber}
                onChange={(e) => setBookingNumber(e.target.value)}
                fullWidth
                required={requiredFields.includes('bookingNumber')}
                InputLabelProps={getInputLabelProps('bookingNumber')}
              />
            </Grid>

            {/* Driver's License Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Driver's License Number"
                value={driversLicenseNumber}
                onChange={(e) => setDriversLicenseNumber(e.target.value)}
                fullWidth
                required={requiredFields.includes('driversLicenseNumber')}
                InputLabelProps={getInputLabelProps('driversLicenseNumber')}
              />
            </Grid>

            {/* Driver's License State */}
            <Grid item xs={12} sm={6}>
            <Autocomplete
              options={US_STATES}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => setDriversLicenseState(newValue?.code || '')}
              value={US_STATES.find((state) => state.code === driversLicenseState) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Driver's License State"
                  fullWidth
                  required={requiredFields.includes('driversLicenseState')}
                  InputLabelProps={getInputLabelProps('driversLicenseState')}
                />
              )}
            />
            </Grid>

            {/* Race */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Race"
                value={race}
                onChange={(e) => setRace(e.target.value)}
                fullWidth
                required={requiredFields.includes('race')}
                InputLabelProps={getInputLabelProps('race')}
              />
            </Grid>

            {/* Gender Dropdown */}
            <Grid item xs={12} sm={6}>
            <Autocomplete
              options={genderOptions}
              getOptionLabel={(option) => option.label}
              onChange={(e, newValue) => setGender(newValue?.value || '')}
              value={genderOptions.find((option) => option.value === gender) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Gender"
                  fullWidth
                  required={requiredFields.includes('gender')}
                  InputLabelProps={getInputLabelProps('gender')}
                />
              )}
            />
            </Grid>

            {/* Place of Birth */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Place of Birth"
                value={placeOfBirth}
                onChange={(e) => setPlaceOfBirth(e.target.value)}
                fullWidth
                required={requiredFields.includes('placeOfBirth')}
                InputLabelProps={getInputLabelProps('placeOfBirth')}
              />
            </Grid>

            {/* Social Security Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Social Security Number"
                value={socialSecurityNumber}
                onChange={(e) => {
                  const input = e.target.value;
                  // Only allow numbers and limit to 9 characters
                  if (/^\d*$/.test(input) && input.length <= 9) {
                    setSocialSecurityNumber(input);
                  }
                }}
                fullWidth
                required={requiredFields.includes('socialSecurityNumber')}
                inputProps={{
                  maxLength: 9, // Maximum length for the input
                  inputMode: 'numeric', // Numeric keyboard on mobile devices
                }}
                InputLabelProps={getInputLabelProps('socialSecurityNumber')}
              />
            </Grid>

            {/* Arrest Date */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Arrest Date"
                type="date"
                value={arrestDate}
                onChange={(e) => setArrestDate(e.target.value)}
                fullWidth
                InputLabelProps={getInputLabelProps('arrestDate')}
                required={requiredFields.includes('arrestDate')}
              />
            </Grid>

            {/* Jail Phone Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Jail Phone Number"
                value={jailPhoneNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setJailPhoneNumber(value);
                }}
                fullWidth
                required={requiredFields.includes('jailPhoneNumber')}
                InputLabelProps={getInputLabelProps('jailPhoneNumber')}
              />
            </Grid>

            {/* Jail Info */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Jail Info"
                value={jailInfo}
                onChange={(e) => setJailInfo(e.target.value)}
                fullWidth
                required={requiredFields.includes('jailInfo')}
                InputLabelProps={getInputLabelProps('jailInfo')}
              />
            </Grid>
          </Grid>

          {/* Bond Information */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
            Bond Information
          </Typography>
            {
              powers.map((item, index) => 
                <FormControl component="fieldset" sx={{ border: "1px solid lightgrey", borderRadius: 2, padding: 2 }}>
                  <FormLabel  component="legend" sx={{fontWeight: "bold", paddingLeft: 1, paddingRight: 1 }} >Power #{index+1} </FormLabel>
                  <FormGroup>
                    <Grid spacing={2} container key={index}>
                      <Grid item xs={12} sm="auto">
                        <TextField
                          label="Bond Amount"
                          value={item.bondAmount}
                          onChange={(e) => updatePower(index, "bondAmount", e.target.value.replace(/[^0-9.]/g, ''))}
                          fullWidth
                          required
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          }}
                          InputLabelProps={getInputLabelProps('bondAmount')}
                          sx={{
                            '& .MuiFormLabel-asterisk': {
                              color: '#d32f2f',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        <TextField
                          label="Charge"
                          value={powers[index].charge}
                          onChange={(e) => updatePower(index, "charge", e.target.value)}
                          fullWidth
                          required
                          InputLabelProps={getInputLabelProps('charge')}
                          sx={{
                            '& .MuiFormLabel-asterisk': {
                              color: '#d32f2f',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        <TextField
                          label="Charge Type (Misd./Felony)"
                          value={powers[index].chargeType}
                          onChange={(e) => updatePower(index, "chargeType", e.target.value)}
                          fullWidth
                          InputLabelProps={getInputLabelProps('chargeType')}
                          sx={{
                            '& .MuiFormLabel-asterisk': {
                              color: '#d32f2f',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        <TextField
                          label="Case Number"
                          value={powers[index].caseNumber}
                          onChange={(e) => updatePower(index, "caseNumber", e.target.value)}
                          fullWidth
                          InputLabelProps={getInputLabelProps('caseNumber')}
                        />
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        <TextField
                          label="Courthouse"
                          value={powers[index].courtPlace}
                          onChange={(e) => updatePower(index, "courtPlace", e.target.value.substring(0,80))}
                          fullWidth
                          InputLabelProps={getInputLabelProps('courtPlace')}
                        />
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        <TextField
                          label="Court Date"
                          type="date"
                          value={powers[index].courtDate}
                          onChange={(e) => updatePower(index, "courtDate", e.target.value)}
                          fullWidth
                          InputLabelProps={getInputLabelProps('courtDate')}
                          required={requiredFields.includes('courtDateFound')}
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>
                
              )
            }

          {/* Bond Amount Running Total */}
          {powers.length > 0 && (() => {
            const sumOfPowers = powers.reduce((sum, p) => sum + (parseFloat(p.bondAmount) || 0), 0);
            const total = parseFloat(totalBondAmount) || 0;
            const isMatched = Math.abs(sumOfPowers - total) <= 0.01;
            const remaining = total - sumOfPowers;
            const emptyPowers = powers.filter(p => !(parseFloat(p.bondAmount) > 0));
            const hasEmptyPowers = emptyPowers.length > 0;
            return (
              <>
                <Alert
                  severity={isMatched && !hasEmptyPowers ? 'success' : 'warning'}
                  icon={isMatched && !hasEmptyPowers ? <CheckIcon /> : <WarningIcon />}
                  sx={{ mt: 2, mb: 1 }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography variant="body2" fontWeight="bold">
                      Bond Amounts Entered: ${sumOfPowers.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      {' of '}
                      ${total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Typography>
                    {!isMatched && (
                      <Typography variant="body2" sx={{ ml: 2 }}>
                        {remaining > 0
                          ? `$${remaining.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} remaining`
                          : `$${Math.abs(remaining).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} over`}
                      </Typography>
                    )}
                  </Box>
                </Alert>
                {hasEmptyPowers && (
                  <Alert severity="error" icon={<WarningIcon />} sx={{ mt: 1, mb: 1 }}>
                    <Typography variant="body2">
                      Bond amount is required for {emptyPowers.length === 1
                        ? `Power #${emptyPowers[0].id + 1}`
                        : `Powers #${emptyPowers.map(p => p.id + 1).join(', #')}`
                      }. All bonds must have an amount entered.
                    </Typography>
                  </Alert>
                )}
              </>
            );
          })()}

          {/* Defendant Address */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
            Defendant Address
          </Typography>

          <Grid container spacing={2}>
            {/* Defendant Street */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Street"
                value={defendantStreet}
                onChange={(e) => setDefendantStreet(e.target.value)}
                fullWidth
                required={requiredFields.includes('defendantStreet')}
                InputLabelProps={getInputLabelProps('defendantStreet')}
              />
            </Grid>

            {/* Defendant City */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="City"
                value={defendantCity}
                onChange={(e) => setDefendantCity(e.target.value)}
                fullWidth
                required={requiredFields.includes('defendantCity')}
                InputLabelProps={getInputLabelProps('defendantCity')}
              />
            </Grid>

            {/* Defendant State */}
            <Grid item xs={12} sm={6}>
            <Autocomplete
              options={US_STATES}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => setDefendantState(newValue?.code || '')}
              value={US_STATES.find((state) => state.code === defendantState) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="State"
                  fullWidth
                  required={requiredFields.includes('defendantState')}
                  InputLabelProps={getInputLabelProps('defendantState')}
                />
              )}
            />
            </Grid>

            {/* Defendant Zip Code */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Zip Code"
                value={defendantZipCode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setDefendantZipCode(value);
                }}
                fullWidth
                required={requiredFields.includes('defendantZipCode')}
                inputProps={{ maxLength: 5 }}
                InputLabelProps={getInputLabelProps('defendantZipCode')}
              />
            </Grid>

            {/* Defendant Phone Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Phone Number"
                value={defendantPhoneNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setDefendantPhoneNumber(value);
                }}
                fullWidth
                required={requiredFields.includes('defendantPhoneNumber')}
                InputLabelProps={getInputLabelProps('defendantPhoneNumber')}
              />
            </Grid>
          </Grid>

          {/* Additional Information */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
            Additional Information
          </Typography>

          <Grid container spacing={2}>
            {/* Hair Color */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Hair Color"
                value={hairColor}
                onChange={(e) => setHairColor(e.target.value)}
                fullWidth
                required={requiredFields.includes('hairColor')}
                InputLabelProps={getInputLabelProps('hairColor')}
              />
            </Grid>

            {/* Eye Color */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Eye Color"
                value={eyeColor}
                onChange={(e) => setEyeColor(e.target.value)}
                fullWidth
                required={requiredFields.includes('eyeColor')}
                InputLabelProps={getInputLabelProps('eyeColor')}
              />
            </Grid>

            {/* Weight */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Weight"
                value={weight}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setWeight(value);
                }}
                fullWidth
                required={requiredFields.includes('weight')}
                InputProps={{
                  endAdornment: <InputAdornment position="end">lbs</InputAdornment>,
                }}
                InputLabelProps={getInputLabelProps('weight')}
              />
            </Grid>

            {/* Height */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Height"
                value={height}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setHeight(value);
                }}
                fullWidth
                required={requiredFields.includes('height')}
                InputProps={{
                  endAdornment: <InputAdornment position="end">inches</InputAdornment>,
                }}
                InputLabelProps={getInputLabelProps('height')}
              />
            </Grid>

            {/* XREF Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="XREF Number"
                value={xrefNumber}
                onChange={(e) => setXrefNumber(e.target.value)}
                fullWidth
                required={requiredFields.includes('xrefNumber')}
                InputLabelProps={getInputLabelProps('xrefNumber')}
              />
            </Grid>

            {/* PFN Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="PFN Number"
                value={pfnNumber}
                onChange={(e) => setPfnNumber(e.target.value)}
                fullWidth
                required={requiredFields.includes('pfnNumber')}
                InputLabelProps={getInputLabelProps('pfnNumber')}
              />
            </Grid>
          </Grid>

          {/* Next of Kin */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
            Next of Kin
          </Typography>

          <Grid container spacing={2}>
            {/* Next of Kin Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                value={nextOfKinName}
                onChange={(e) => setNextOfKinName(e.target.value)}
                fullWidth
                required={requiredFields.includes('nextOfKinName')}
                InputLabelProps={getInputLabelProps('nextOfKinName')}
              />
            </Grid>

            {/* Next of Kin Phone Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Phone Number"
                value={nextOfKinPhoneNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setNextOfKinPhoneNumber(value);
                }}
                fullWidth
                required={requiredFields.includes('nextOfKinPhoneNumber')}
                InputLabelProps={getInputLabelProps('nextOfKinPhoneNumber')}
              />
            </Grid>

            {/* Next of Kin Address Street 1 */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Street 1"
                value={nextOfKinAddressStreet1}
                onChange={(e) => setNextOfKinAddressStreet1(e.target.value)}
                fullWidth
                required={requiredFields.includes('nextOfKinAddressStreet1')}
                InputLabelProps={getInputLabelProps('nextOfKinAddressStreet1')}
              />
            </Grid>

            {/* Next of Kin Address Street 2 */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Street 2"
                value={nextOfKinAddressStreet2}
                onChange={(e) => setNextOfKinAddressStreet2(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true, sx: { fontSize: '1.1rem' } }}
              />
            </Grid>

            {/* Next of Kin Address City */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="City"
                value={nextOfKinAddressCity}
                onChange={(e) => setNextOfKinAddressCity(e.target.value)}
                fullWidth
                required={requiredFields.includes('nextOfKinAddressCity')}
                InputLabelProps={getInputLabelProps('nextOfKinAddressCity')}
              />
            </Grid>

            {/* Next of Kin Address State */}
            <Grid item xs={12} sm={4}>
            <Autocomplete
              options={US_STATES}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => setNextOfKinAddressState(newValue?.code || '')}
              value={US_STATES.find((state) => state.code === nextOfKinAddressState) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="State"
                  fullWidth
                  required={requiredFields.includes('nextOfKinAddressState')}
                  InputLabelProps={getInputLabelProps('nextOfKinAddressState')}
                />
              )}
            />
            </Grid>

            {/* Next of Kin Address Zip Code */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="Zip Code"
                value={nextOfKinAddressZipCode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setNextOfKinAddressZipCode(value);
                }}
                fullWidth
                required={requiredFields.includes('nextOfKinAddressZipCode')}
                inputProps={{ maxLength: 5 }}
                InputLabelProps={getInputLabelProps('nextOfKinAddressZipCode')}
              />
            </Grid>
          </Grid>

          {/* Nearest Relative */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
            Nearest Relative
          </Typography>

          <Grid container spacing={2}>
            {/* Nearest Relative Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                value={nearestRelativeName}
                onChange={(e) => setNearestRelativeName(e.target.value)}
                fullWidth
                required={requiredFields.includes('nearestRelativeName')}
                InputLabelProps={getInputLabelProps('nearestRelativeName')}
              />
            </Grid>

            {/* Nearest Relative Address Street 1 */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Street 1"
                value={nearestRelativeAddressStreet1}
                onChange={(e) => setNearestRelativeAddressStreet1(e.target.value)}
                fullWidth
                required={requiredFields.includes('nearestRelativeAddressStreet1')}
                InputLabelProps={getInputLabelProps('nearestRelativeAddressStreet1')}
              />
            </Grid>

            {/* Nearest Relative Address Street 2 */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Street 2"
                value={nearestRelativeAddressStreet2}
                onChange={(e) => setNearestRelativeAddressStreet2(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true, sx: { fontSize: '1.1rem' } }}
              />
            </Grid>

            {/* Nearest Relative Address City */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="City"
                value={nearestRelativeAddressCity}
                onChange={(e) => setNearestRelativeAddressCity(e.target.value)}
                fullWidth
                required={requiredFields.includes('nearestRelativeAddressCity')}
                InputLabelProps={getInputLabelProps('nearestRelativeAddressCity')}
              />
            </Grid>

            {/* Nearest Relative Address State */}
            <Grid item xs={12} sm={4}>
            <Autocomplete
              options={US_STATES}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => setNearestRelativeAddressState(newValue?.code || '')}
              value={US_STATES.find((state) => state.code === nearestRelativeAddressState) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="State"
                  fullWidth
                  required={requiredFields.includes('nearestRelativeAddressState')}
                  InputLabelProps={getInputLabelProps('nearestRelativeAddressState')}
                />
              )}
            />
            </Grid>

            {/* Nearest Relative Address Zip Code */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="Zip Code"
                value={nearestRelativeAddressZipCode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setNearestRelativeAddressZipCode(value);
                }}
                fullWidth
                required={requiredFields.includes('nearestRelativeAddressZipCode')}
                inputProps={{ maxLength: 5 }}
                InputLabelProps={getInputLabelProps('nearestRelativeAddressZipCode')}
              />
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={loading || powers.length === 0 || powers.some(p => !(parseFloat(p.bondAmount) > 0)) || Math.abs(powers.reduce((sum, p) => sum + (parseFloat(p.bondAmount) || 0), 0) - (parseFloat(totalBondAmount) || 0)) > 0.01}
              startIcon={loading ? <CircularProgress size={20} /> : null}
            >
              Accept Quote
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setDeclineModalOpen(true)}
              disabled={loading}
            >
              Decline Quote
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleModalClose}
              disabled={loading}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Decline Quote Modal */}
      <Modal
        open={declineModalOpen}
        onClose={handleDeclineModalClose}
        aria-labelledby="decline-quote-modal-title"
        aria-describedby="decline-quote-form"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '60%', md: '40%' },
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography id="decline-quote-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
            Decline Quote
          </Typography>
          <TextField
            label="Reason for Declining"
            multiline
            rows={4}
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ mb: 3 }}
            InputLabelProps={{ shrink: true, sx: { fontSize: '1.1rem' } }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDeclineSubmit}
              disabled={declineLoading}
              startIcon={declineLoading ? <CircularProgress size={20} /> : null}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleDeclineModalClose}
              disabled={declineLoading}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default QuoteDetailsModal;
